export default __webpack_public_path__ + "static/media/jenkins.588fa279.svg";